<template>
    <div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <!-- <h5 class="card-category"></h5> -->
                        <h3 class="card-title">
                            TEST
                        </h3>

                    </template>
                    
                    

                    <div class="row">
                        <div class="col-md-6">
                            <card class="">
                                <h2 style="color: cadetblue;">SMS</h2>
                                <base-input label="Broj" v-model="sms.number"/>
                                <base-input label="Kod" v-model="sms.shortNumber"/>
                                <base-input label="Tablice" v-model="sms.plates"/>
                                <base-input label="Operater" v-model="sms.operator"/>
                                <base-button class="mt-3" native-type="submit" type="primary"
                                    @click="newSms()">Posalji</base-button>
                                <base-button v-if="sms.id" class="mt-3" native-type="submit" type="primary"
                                    @click="savePayment()">Naplati</base-button>

                            </card>
                        </div>
                        <div class="col-md-6">
                            <card class="">
                                <h2 style="color: cadetblue;">Kontrolor</h2>
                                <base-input label="Tablice" v-model="plates.plates"/>
                                <base-input label="Parking id" v-model="plates.parkingId"/>
                                <base-input label="Employee id" v-model="plates.employeeId"/>
                                <base-input label="Space od" v-model="plates.parkingSpaceId"/>
                                <base-button class="mt-3" native-type="submit" type="primary"
                                    @click="checkPlates()">Proveri</base-button>
                                <pre>{{ platesResponse }}</pre>
                                <!-- <base-button v-if="sms.id" class="mt-3" native-type="submit" type="primary"
                                    @click="savePayment()">Naplati</base-button> -->


                            </card>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <card class="">
                                <h2 style="color: cadetblue;">Bez slika</h2>
                                <base-input>
                                    <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp" format="dd.MM.yyyy. HH:mm:ss"
                                        v-model="stamp">
                                    </el-date-picker>
                                </base-input>
                                
                                <base-button class="mt-3" native-type="submit" type="primary"
                                    @click="checkImages()">Proveri</base-button>
                                <pre>{{ imagesResponse }}</pre>

                            </card>
                        </div>
                        <div class="col-md-6">
                        </div>
                    </div>

                    

                </card>
            </div>
        </div>

        <modal :show.sync="showTicket" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicket = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <div class="row">
                <div class="col-md-12">
                    <card>
                        Opis: {{ paukTicket.description }}<br>
                        {{ paukTicket.plates }}<br>
                        {{ paukTicket.street }}<br>
                        {{ paukTicket.vehicle }}
                    </card>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <card>
                        <template v-for="img in paukTicket.images">
                        <img class="card-img" style="width: 150px;"
                            @click="image = 'https://budva.scancar.org:8443' + img; showImage = true"
                            :src="'https://budva.scancar.org:8443' + img" alt="Image" />&nbsp;
                    </template>
                    </card>
                </div>

            </div>
            
            

        </modal>
        <modal :show.sync="showImage" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showImage = false; image = null">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">{{ paukTicket.plates }}</h4>
                <img class="card-img" :src="image" alt="Image" />&nbsp;

            </card>


        </modal>
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { TimeSelect, Table, TableColumn, Select, Option, DatePicker } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getCurrentUser()
        // this.getUsers()
        // this.getEmployees()
        // this.getKiosks()
        // this.getRegions()
        // this.getRoles()
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            activeName: 'first',
            sectors: [],
            url: 'https://budva.scancar.org:8443/kuca',
            user: {},
            loading: false,
            filter: {
                startStamp: null,
                endStamp: null,
                plates: null
            },
            openTickets: [],
            paidTickets: [],
            canceledTickets: [],
            overpaidTickets: [],
            partialyPaidTickets: [],
            kioskTickets: [],
            sms: [],
            whitelist: [],
            ticketsLoading: false,
            ticketData: [],
            whitelistLoading: false,
            tickets: [],
            paukTicket: {},
            paukTickets: [],
            showTicket: false,
            image: null,
            showImage: false,
            sms: {
                number: "381642409349",
                plates: "BG2591XK",
                shortNumber: "14510",
                operator: "MTEL",
                id: null
            },
            plates: {
                employeeId: "dd9c9b09839e0c8cx40bffa27x1936497d74ax-663f",
                parkingId: "56",
                parkingSpaceId: "845",
                plates: "BG2591XK"
            },
            platesResponse: {},
            stamp: startStamp,
            imagesResponse: {}
        };
    },
    methods: {
        checkImages() {
            this.loading = true

            const body = {
                stamp: this.stamp
            }
            axios.post(this.url + '/services/checkImages', body).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.imagesResponse = JSON.stringify(result.data, null, 2)
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        checkPlates() {
            this.loading = true

            axios.post(this.url + '/employee/checkPlates', this.plates).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.platesResponse = JSON.stringify(result.data, null, 2)
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        newSms() {
            this.loading = true

            axios.post(this.url + '/sms/newSms', this.sms).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.sms.id = result.data.id
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        savePayment() {
            this.loading = true
            const body = {
                success: true,
                id: this.sms.id
            }
            axios.post(this.url + '/sms/savePayment', body).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.sms.id = null
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getPaukTicket(t) {
            this.loading = true

            axios.get(this.url + '/pauk/getTicket?id=' + t.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.paukTicket = result.data.ticket
                    this.showTicket = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },

        getCurrentUser() {
            this.zonesLoading = true
            axios.get(this.url + '/user/getUser').then(result => {
                this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.user = result.data.user
                    // alert(this.user.userName)
                } else {

                }
            })
        },
        checkPaukTickets() {
            this.paukTicket = {}
            this.paukTickets = []
            // this.ticketsLoading = true
            axios.post(this.url + '/callcenter/checkPaukTickets', this.filter).then(result => {
                // this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    if (result.data.paukTicket) {
                        this.paukTicket = result.data.paukTicket
                        this.paukTickets.push(this.paukTicket)

                        if (this.paukTicket.ticketType === 0) {
                            const swalWithBootstrapButtons4 = swal.mixin({
                                customClass: {
                                    confirmButton: "btn btn-success btn-fill",
                                    cancelButton: "btn btn-danger btn-fill",
                                },
                                buttonsStyling: false,
                            });
                            let txt = "Vozilo je odneseno na lokaciju: " + this.paukTicket.paukLocation.name
                            swalWithBootstrapButtons4
                                .fire({
                                    title: txt,
                                    text: '',
                                    confirmButtonText: "U redu",
                                    // cancelButtonText: "ODUSTANI",
                                    showCancelButton: false,
                                })
                                .then((result) => {
                                    if (result.value) {

                                    }
                                });
                        }
                        if (this.paukTicket.ticketType === 1) {
                            const swalWithBootstrapButtons4 = swal.mixin({
                                customClass: {
                                    confirmButton: "btn btn-success btn-fill",
                                    cancelButton: "btn btn-danger btn-fill",
                                },
                                buttonsStyling: false,
                            });
                            let txt = "Vozilo ima lisice"
                            swalWithBootstrapButtons4
                                .fire({
                                    title: txt,
                                    text: '',
                                    confirmButtonText: "U redu",
                                    // cancelButtonText: "ODUSTANI",
                                    showCancelButton: false,
                                })
                                .then((result) => {
                                    if (result.value) {

                                    }
                                });
                        }
                    }

                } else {

                }
            })
        },
        checkSms() {
            this.sms = []
            this.ticketsLoading = true
            axios.post(this.url + '/callcenter/checkSms', this.filter).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.sms = result.data.sms

                } else {

                }
            })
        },
        checkKioskTickets() {
            this.kioskTickets = []
            this.ticketsLoading = true
            axios.post(this.url + '/callcenter/checkKioskTickets', this.filter).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.kioskTickets = result.data.kioskTickets

                } else {

                }
            })
        },
        checkTickets() {
            this.ticketData = []
            this.ticketsLoading = true
            axios.post(this.url + '/callcenter/checkTickets', this.filter).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.openTickets = result.data.openTickets
                    this.paidTickets = result.data.paidTickets
                    this.canceledTickets = result.data.canceledTickets
                    this.overpaidTickets = result.data.overpaidTickets
                    this.partialyPaidTickets = result.data.partialyPaidTickets

                    this.tickets = this.openTickets

                    const d = {
                        openTickets: this.openTickets.length,
                        paidTickets: this.paidTickets.length,
                        canceledTickets: this.canceledTickets.length,
                        overpaidTickets: this.overpaidTickets.length,
                        partialyPaidTickets: this.partialyPaidTickets.length
                    }
                    this.ticketData = []
                    this.ticketData.push(d)
                } else {

                }
            })
        },
        checkWhitelist() {
            this.whitelist = []
            this.whitelistLoading = true
            axios.post(this.url + '/callcenter/checkWhitelist', this.filter).then(result => {
                this.whitelistLoading = false

                if (result.data.result === 'ok') {

                    // this.kioskTickets = result.data.kioskTickets
                    // this.sms = result.data.sms
                    this.whitelist = result.data.whitelist
                } else {

                }
            })
        },
        changePassword() {
            this.loading = true
            axios.post(this.url + '/user/changePassword', this.user).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getCurrentUser()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        }
    }
};
</script>
<style lang="scss" scoped>
.scrollable-card {
    height: 500px;
    /* ili željena visina */
    overflow-y: auto;
    position: relative;
    /* po potrebi, ako ima apsolutno pozicioniranih elemenata */
}

/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>